module.exports = __webpack_public_path__ + "media/images/5-43f202aa8d4c7449b679be362ef68532.jpg";